/**
 * @generated SignedSource<<a8d4d724524b610267da89b8bca38189>>
 * @relayHash 85648ac81a95ae975eaf21dd415994b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 74a4e588cf20768ee3bc8ac6c48705618ab7e5f296aa734d7569a41335d96772

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { boardFilterRefinementQuery } from './boardFilterRefinementQuery.graphql';

const node: PreloadableConcreteRequest<boardFilterRefinementQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "74a4e588cf20768ee3bc8ac6c48705618ab7e5f296aa734d7569a41335d96772",
    "metadata": {},
    "name": "boardFilterRefinementQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
